<template>
  <div class="ine-form__form-wrapper">
    <form class="ine-form__form" @submit.prevent="validateFields">
      <Title
        header="Change Your Password"
        tagline="Please enter your current password and the new password."
      />
      <Errors :errors="errors.messages" />
      <div
        v-for="(field, key) in fields"
        v-show="field.type"
        :key="`field-${key}`"
        class="ine-form__form-group"
      >
        <input
          v-if="field.type"
          :type="field.type"
          :class="[
            'ine-form__form-control',
            errors.fields.includes(key) && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          :placeholder="field.placeholder"
          :autocomplete="field.autocomplete"
          v-model="field.value"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn title="Submit" :isLoading="isLoading" />
      </div>
      <AdditionalLinks :linksShown="[]" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'UpdatePasswordForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    AdditionalLinks,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        'current password': {
          type: 'password',
          rules: ['presence'],
          placeholder: 'Current Password',
          value: '',
          autocomplete: 'current-password',
        },
        'new password': {
          type: 'password',
          rules: ['presence', 'password'],
          placeholder: 'New Password',
          value: '',
          autocomplete: 'new-password',
        },
        'password confirmation': {
          type: 'password',
          rules: ['presence'],
          placeholder: 'Confirm New Password',
          value: '',
          autocomplete: 'new-password',
        },
      },
    }
  },
  computed: {
    isPasswordConfirmed() {
      return (
        this.fields['new password'].value ===
        this.fields['password confirmation'].value
      )
    },
  },
  methods: {
    validateFields() {
      if (!this.isPasswordConfirmed) {
        this.errors = {
          fields: ['new password', 'password confirmation'],
          messages: ['Passwords do not match'],
        }
        return
      }
      const { fields } = this
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          password: fields['new password'].value,
          currentPassword: fields['current password'].value,
        }
        this.$emit('submit-form', payload)
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>
